<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">样本册：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="样本册"
                clearable
                v-model="queryData.sampleName"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search-form-label">页码：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="页码"
                clearable
                v-model="queryData.page"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search-form-label">品番：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="品番"
                clearable
                v-model="queryData.merchandiseNumber"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空
            </el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
          <el-upload
            :action="this.$apis.uploadFiles"
            class="upload-demo"
            style="float:left"
            accept=".xls,.xlsx"
            :on-success="successHandle"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-button-group>
        <el-select style="margin-left:100px" size="small" v-model="delSampleName" filterable placeholder="请选择产品">
          <el-option v-for="item in products" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-button style="margin-left:10px" size="small" type="danger" @click="deldelSampleNameFun">删除样本册</el-button>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
          @selection-change="selectHandler"
        >
          <el-table-column
            type="selection"
            width="40"
            align="center"
          ></el-table-column>
          <el-table-column
            label="样本册"
            prop="sampleName"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            label="页码"
            prop="page"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="品番"
            prop="merchandiseNumber"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="担当"
            prop="undertake"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            label="样本册编号"
            prop="sampleNo"
            width="300"
            align="center"
          ></el-table-column>
          <el-table-column
            label="备注"
            prop="remark"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" width="60" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                circle
                icon="el-icon-minus"
                @click.stop.prevent="handlerDel(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
export default {
  data: function() {
    return {
      ds: [],
      queryData: {
        sampleName: "",
        page: "",
        merchandiseNumber:"",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id"),
      selectedBoxs: [],
      delSampleName: "",
      products: []
    };
  },
  created: function() {
    this.loadProducts()
  },
  mounted: function() {
    this.loadData();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 加载数据
    loadProducts: function () {
      const _this = this
      _this.post(_this.$apis.getUnderTakeProducts, {}, function (res) {
        const _json = res.data
        _this.products = _json.datalist
      })
    },
    deldelSampleNameFun: function () {
      let _this = this;
      if (_this.delSampleName === '') {
        _this.$message({
          type: "warning",
          message: "请选择样本册"
        });
      } else {
        _this
          .$confirm("此操作将永久删除该样本册数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            let _params = {
              sampleName: _this.delSampleName
            };
            // ajax提交至服务器，删除数据
            _this.post(_this.$apis.delSampleName, _params, function(res) {
              let _json = res.data;
              if (_json.status === "ok") {
                _this.delSampleName = '';
                _this.loadProducts();
                _this.loadData();
                _this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                _this.$message({
                  type: "error",
                  message: "无数据更新!"
                });
              }
            });
          })
          .catch(() => {
            _this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getundertakeList, this.queryData, function(res) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
        }
      });
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.sampleName = "";
        this.queryData.page = "";
        this.queryData.merchandiseNumber = ""; 
      }
      this.loadData();
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      this.loadData();
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      this.loadData();
    },
    // 多选事件
    selectHandler: function(selection) {
      this.selectedBoxs = selection;
    },
    // 删除
    delHandler: function(_row) {
      let _this = this;
      let selectedIds = [];
      for (let _i = 0; _i < _this.selectedBoxs.length; ++_i) {
        selectedIds.push(_this.selectedBoxs[_i].id);
      }

      if (selectedIds.length === 0) {
        _this.$message({
          type: "warning",
          message: "至少选择一条数据"
        });
      } else {
        _this
          .$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            let _params = {
              ids: selectedIds.join(","),
              operator_id: _this.operator_id
            };
            // ajax提交至服务器，删除数据
            _this.post(_this.$apis.delUnderTakes, _params, function(res) {
              let _json = res.data;
              if (_json.status === "ok") {
                _this.loadData();
                _this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                _this.$message({
                  type: "error",
                  message: "无数据更新!"
                });
              }
            });
          })
          .catch(() => {
            _this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
    handlerDel: function(_row) {
      let _this = this;
      _this
        .$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          let _params = {
            id: _row.id
          };
          // ajax提交至服务器，删除数据
          _this.post(_this.$apis.delundertake, _params, function(res) {
            let _json = res.data;
            if (_json.status === "ok") {
              _this.loadData();
              _this.$message({
                type: "success",
                message: "删除成功!"
              });
            } else {
              _this.$message({
                type: "error",
                message: "无数据更新!"
              });
            }
          });
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    successHandle: function(response, file, fileList) {
      if (/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
        this.readExcel(file.raw);
      } else {
        this.$message({
          type: "error",
          message: "只能上传.xls和.xlsx文件"
        });
      }
    },
    readExcel(file) {
      let _this = this;
      const fileReader = new FileReader();
      fileReader.onloadend = ev => {
        _this.$forceUpdate();
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
            cellDates: true
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);
          const header = this.get_header_row(workbook.Sheets[wsname]);

          _this.post(
            _this.$apis.insertExcelData,
            { excelData: ws, operator_id: _this.operator_id },
            function(res) {
              const _json = res.data;
              if (_json.status === "ok") {
                _this.$message({
                  type: "success",
                  message: "上传成功!"
                });
                _this.loadData();
              } else {
                _this.$message({
                  type: "error",
                  message: "上传失败!"
                });
              }
            }
          );
        } catch (e) {
          return false;
        }
      };
      fileReader.readAsBinaryString(file);
    },
    get_header_row(sheet) {
      const headers = [];
      /* sheet['!ref']表示所有单元格的范围，例如从A1到F8则记录为 A1:F8*/
      const range = XLSX.utils.decode_range(sheet["!ref"]);
      let C,
        R = range.s.r; /* 从第一行开始 */
      /* 按列进行数据遍历 */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* 查找第一行中的单元格 */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];

        let hdr = "UNKNOWN " + C; // <-- 进行默认值设置
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);

        headers.push(hdr);
      }
      return headers;
    }
  },
  components: {}
};
</script>
